import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Seo, PageHeader, CtaLink } from "@/components/common";
import { ScanFace, Sparkles, Stethoscope, ShieldCheck } from "lucide-react";

export default function Dental() {
  const { t } = useApp();
  const services = [
    { icon: ScanFace, title: { tr: "Dijital Gülüş Analizi", en: "Digital Smile Analysis" }, desc: { tr: "Yüz oranları, dudak hattı ve diş formlarının dijital ortamda incelenmesi. Tasarım yerleştirme öncesi ekranda gösterilir.", en: "Digital examination of facial proportions, lip line and tooth forms. The design is shown on screen before placement." } },
    { icon: Sparkles, title: { tr: "Kişiye Özel Zirkonyum", en: "Personalised Zirconium" }, desc: { tr: "Üç katmanlı yapı ve doğal form prensipleriyle planlanan zirkonyum restorasyonlar.", en: "Zirconium restorations planned with a three-layer structure and natural form principles." }, to: "/tedaviler/zirkonyum" },
    { icon: Stethoscope, title: { tr: "Genel Diş Tedavileri", en: "General Dental Treatments" }, desc: { tr: "Dolgu, kanal tedavisi, diş eti sağlığı ve koruyucu hekimlik uygulamaları.", en: "Fillings, root canal treatment, gum health and preventive dentistry." } },
    { icon: ShieldCheck, title: { tr: "Koruyucu Bakım ve Takip", en: "Preventive Care and Follow-up" }, desc: { tr: "Tedavi sonrası bakım planı ve ülkenize döndükten sonra uzaktan takip.", en: "Post-treatment care plan and remote follow-up after you return home." } },
  ];

  return (
    <main data-testid="dental-page">
      <Seo title={t({ tr: "Diş Tedavileri ve Dijital Gülüş Analizi", en: "Dental Treatments and Digital Smile Analysis" })} description={t({ tr: "İstanbul'da dijital gülüş analizi, zirkonyum ve genel diş tedavileri.", en: "Digital smile analysis, zirconium and general dental treatments in Istanbul." })} />
      <PageHeader
        tag={{ tr: "Diş tedavileri", en: "Dental treatments" }}
        title={{ tr: "Diş tedavileri ve dijital gülüş analizi", en: "Dental treatments and digital smile analysis" }}
        subtitle={{ tr: "Tüm planlama dijital ortamda yapılır; kararlar sizinle birlikte alınır.", en: "All planning happens digitally; decisions are made together with you." }}
      />
      <section className="max-w-6xl mx-auto px-6 md:px-12 pb-8">
        <div className="grid md:grid-cols-2 gap-6">
          {services.map((s, i) => (
            <div key={i} className="rounded-xl glass-card p-8 hover:shadow-lg transition-shadow">
              <div className="w-11 h-11 rounded-[10px] bg-[var(--accent-soft)] flex items-center justify-center mb-5">
                <s.icon size={20} className="text-[var(--accent)]" />
              </div>
              <h2 className="font-heading font-semibold text-[#F2F5F7] text-lg">{t(s.title)}</h2>
              <p className="text-sm text-[#94A3AE] mt-2.5 leading-relaxed">{t(s.desc)}</p>
              {s.to && (
                <Link to={s.to} className="inline-block mt-4 text-sm font-semibold text-[var(--accent)] hover:underline">
                  {t({ tr: "Detaylı incele →", en: "Explore in detail →" })}
                </Link>
              )}
            </div>
          ))}
        </div>
        <div className="mt-12 text-center">
          <CtaLink to="/mirror" testId="dental-mirror-cta">{t({ tr: "ZETA Mirror ile ön değerlendirme başlatın", en: "Start a pre-assessment with ZETA Mirror" })}</CtaLink>
        </div>
      </section>
    </main>
  );
}
